import { Box, Button, Layer, Markdown } from 'grommet';
import { Edit } from 'grommet-icons';
import { actions, assetState$ } from 'modules/asset/asset$';
import { User } from 'modules/auth/types';
import {
  showErrorNotification,
  showSuccessNotification,
} from 'modules/notification/notification$';
import React, { useEffect, useState } from 'react';
import BounceLoader from 'react-spinners/BounceLoader';
import { dispatchAction } from 'rxbeach';
import { connect } from 'rxbeach/react';
import { filter, first } from 'rxjs/operators';
import { ApiServiceState } from 'streams/crudStream/types';
import { Asset } from 'types';
import viewModel$ from '../viewModel$';
import MarkdownEditor from './MarkdownEditor';

const markdownProps = {
  p: {
    component: 'Paragraph',
    props: { size: 'xxlarge' },
  },
};

interface MarkdownActionEditorProps {
  id: string;
  user: User | null;
  byId: Record<string, Asset>;
  state: ApiServiceState;
}

const MarkdownActionEditor = ({
  id,
  user,
  byId,
  state,
}: MarkdownActionEditorProps) => {
  const asset = byId?.[id];
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(asset?.markdown);

  const save = async () => {
    dispatchAction(actions.apiPut([{ ...asset, markdown: value }]));
    assetState$
      .pipe(
        filter(({ state }) => state !== ApiServiceState.LOADING),
        first()
      )
      .subscribe(({ state }) => {
        if (state === ApiServiceState.SUCCESS) {
          setEditing(false);
          dispatchAction(showSuccessNotification('Teksten er oppdatert!'));
        } else {
          dispatchAction(showErrorNotification('Noe gikk feil.'));
        }
      });
  };

  const abort = () => {
    setEditing(false);
    setValue(asset.markdown);
  };

  useEffect(() => {
    setValue(asset?.markdown);
  }, [asset?.markdown]);

  if (!asset) return null;
  return editing ? (
    <Box pad="small">
      <MarkdownEditor markdown={value} setMarkdown={setValue} />
      <Box direction="row" justify="center" align="center" pad="small">
        <Button primary size="medium" onClick={save} label="Lagre" />
        <Button size="medium" onClick={abort} label="Avbryt" />
      </Box>
      {state === ApiServiceState.LOADING && (
        <Layer full plain animation="fadeIn">
          <Box
            fill
            align="center"
            justify="center"
            background="#f5f5f5"
            style={{ opacity: '0.5' }}
          >
            <BounceLoader size={80} color="red" loading={true} />
          </Box>
        </Layer>
      )}
    </Box>
  ) : (
    <Box>
      {user && (
        <Box direction="row" justify="end" align="center" pad="small">
          <Button
            size="small"
            onClick={() => setEditing(true)}
            icon={<Edit />}
            label="Endre tekst"
          />
        </Box>
      )}
      <Markdown {...markdownProps}>{asset.markdown || ''}</Markdown>
    </Box>
  );
};

export default connect(MarkdownActionEditor, viewModel$);
